import React from 'react';
import { _defineHelpUrlandToolTip } from '../helpers/index.js'

const ControlsIf = function () {
    const name = "controls_if";
    ControlsIf.blockName = name;

    _defineHelpUrlandToolTip(name, Blockly.BASE_HELP_URL + "#logic", "if statement for conditional logic");

    return (
        <block type={name} colour="#d9d9d9"></block>
    );
};

export default ControlsIf;
